import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { optimizeImageUrl, optimizeProductImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { isResponsiveProp } from "@faire/web--source/slate/Theme/ResponsiveProp";
import React from "react";
import { EAEAEA_PIXEL } from "@faire/retailer/consts/EAEAEA_PIXEL";
export var objectFitCoverImageStyles = {
    objectFit: "cover",
    objectPosition: "center"
};
var SUPPORTED_DPR = [
    1,
    2
];
export var SDUIImage = function(param) {
    var responsiveImage = param.responsiveImage, optimizeImageOptions = param.optimizeImageOptions, className = param.className, renderBehaviour = param.renderBehaviour, altText = param.altText, isProductImage = param.isProductImage, imageStyles = param.imageStyles, _param_showPlaceholder = param.showPlaceholder, showPlaceholder = _param_showPlaceholder === void 0 ? true : _param_showPlaceholder;
    var _responsiveImage_mobileAndAbove;
    var _getResponsiveImageUrls = getResponsiveImageUrls(responsiveImage, optimizeImageOptions, isProductImage), imageUrlsMobile = _getResponsiveImageUrls.imageUrlsMobile, imageUrlsTablet = _getResponsiveImageUrls.imageUrlsTablet, imageUrlsDesktop = _getResponsiveImageUrls.imageUrlsDesktop;
    var _imageUrlsMobile_, _ref;
    var smallestImageUrlAvailable = (_ref = (_imageUrlsMobile_ = imageUrlsMobile === null || imageUrlsMobile === void 0 ? void 0 : imageUrlsMobile[0]) !== null && _imageUrlsMobile_ !== void 0 ? _imageUrlsMobile_ : imageUrlsTablet === null || imageUrlsTablet === void 0 ? void 0 : imageUrlsTablet[0]) !== null && _ref !== void 0 ? _ref : imageUrlsDesktop === null || imageUrlsDesktop === void 0 ? void 0 : imageUrlsDesktop[0];
    if (!showPlaceholder && !smallestImageUrlAvailable) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("picture", {
        className: className,
        children: [
            (imageUrlsDesktop === null || imageUrlsDesktop === void 0 ? void 0 : imageUrlsDesktop.length) ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: ".concat(MIN_WIDTH_BREAKPOINTS.DESKTOP, "px)"),
                srcSet: buildSrcSet(imageUrlsDesktop)
            }) : null,
            (imageUrlsTablet === null || imageUrlsTablet === void 0 ? void 0 : imageUrlsTablet.length) ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: ".concat(MIN_WIDTH_BREAKPOINTS.TABLET, "px)"),
                srcSet: buildSrcSet(imageUrlsTablet)
            }) : null,
            (imageUrlsMobile === null || imageUrlsMobile === void 0 ? void 0 : imageUrlsMobile.length) ? /*#__PURE__*/ _jsx("source", {
                media: "(min-width: ".concat(MIN_WIDTH_BREAKPOINTS.MOBILE, "px)"),
                srcSet: buildSrcSet(imageUrlsMobile)
            }) : null,
            /*#__PURE__*/ _jsx("img", {
                style: {
                    objectFit: imageStyles === null || imageStyles === void 0 ? void 0 : imageStyles.objectFit,
                    objectPosition: imageStyles === null || imageStyles === void 0 ? void 0 : imageStyles.objectPosition,
                    width: "100%",
                    height: "100%"
                },
                src: smallestImageUrlAvailable !== null && smallestImageUrlAvailable !== void 0 ? smallestImageUrlAvailable : EAEAEA_PIXEL,
                alt: altText !== null && altText !== void 0 ? altText : (_responsiveImage_mobileAndAbove = responsiveImage.mobileAndAbove) === null || _responsiveImage_mobileAndAbove === void 0 ? void 0 : _responsiveImage_mobileAndAbove.alt_text,
                loading: renderBehaviour === null || renderBehaviour === void 0 ? void 0 : renderBehaviour.imagesLoadingStrategy,
                width: "100%",
                height: "100%"
            })
        ]
    });
};
var buildSrcSet = function(imageUrls) {
    return imageUrls.map(function(imageUrl, index) {
        return "".concat(imageUrl, " ").concat(SUPPORTED_DPR[index], "x");
    }).join(", ");
};
var getOptimizedImageUrls = function(image, optimizeImageOptions, isProductImage) {
    if (!image.url) {
        return undefined;
    }
    if (!isProductImage && optimizeImageOptions.resizeMethod && (!optimizeImageOptions.width || !optimizeImageOptions.height)) {
        return undefined;
    }
    return SUPPORTED_DPR.map(function(dpr) {
        var _optimizeImageOptions_width;
        return isProductImage ? optimizeProductImageUrl({
            url: image.url
        }, false, (_optimizeImageOptions_width = optimizeImageOptions.width) !== null && _optimizeImageOptions_width !== void 0 ? _optimizeImageOptions_width : optimizeImageOptions.height, _object_spread_props(_object_spread({}, optimizeImageOptions), {
            dprOverride: dpr
        })) : optimizeImageUrl({
            url: image.url
        }, false, _object_spread_props(_object_spread({}, optimizeImageOptions), {
            dprOverride: dpr
        }));
    }).filter(isNotUndefined);
};
export var getResponsiveImageUrls = function(responsiveImage, optimizeImageOptions, isProductImage) {
    var imageOptionsMobile = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.mobileAndAbove : optimizeImageOptions;
    var imageOptionsTablet = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.tabletAndAbove : undefined;
    var imageOptionsDesktop = isResponsiveProp(optimizeImageOptions) ? optimizeImageOptions.desktopAndAbove : undefined;
    var imageMobile = responsiveImage.mobileAndAbove;
    var imageTablet = responsiveImage.tabletAndAbove;
    var imageDesktop = responsiveImage.desktopAndAbove;
    if (!imageMobile && !imageTablet && !imageDesktop) {
        return {};
    }
    var imageUrlsMobile = getOptimizedImageUrls(imageMobile, imageOptionsMobile, isProductImage);
    var imageUrlsTablet = imageOptionsTablet || imageTablet ? getOptimizedImageUrls(imageTablet !== null && imageTablet !== void 0 ? imageTablet : imageMobile, imageOptionsTablet !== null && imageOptionsTablet !== void 0 ? imageOptionsTablet : imageOptionsMobile, isProductImage) : undefined;
    var _ref, _ref1;
    var imageUrlsDesktop = imageOptionsDesktop || imageDesktop ? getOptimizedImageUrls((_ref = imageDesktop !== null && imageDesktop !== void 0 ? imageDesktop : imageTablet) !== null && _ref !== void 0 ? _ref : imageMobile, (_ref1 = imageOptionsDesktop !== null && imageOptionsDesktop !== void 0 ? imageOptionsDesktop : imageOptionsTablet) !== null && _ref1 !== void 0 ? _ref1 : imageOptionsMobile, isProductImage) : undefined;
    return {
        imageUrlsMobile: imageUrlsMobile,
        imageUrlsTablet: imageUrlsTablet,
        imageUrlsDesktop: imageUrlsDesktop
    };
};
